import VerifyNewDomain from './VerifyNewDomain';

export default VerifyNewDomain;
